// import image from '../assets/images/og.png'

export const META_HOME = {
  metaInfo() {
    return {
      title: this.$t('meta.title.home'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.home'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/`
      }]
    }
  },
}

export const META_USAGE = {
  metaInfo() {
    return {
      title: this.$t('meta.title.usage'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.usage'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/usage`
      }]
    }
  },
}

export const META_STREAMER = {
  metaInfo() {
    return {
      title: this.$t('meta.title.streamer'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.streamer'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/streamer`
      }]
    }
  },
}

export const META_STREAMER_DETAIL = {
  metaInfo() {
    return {
      title: this.$t('meta.title.streamer_detail'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.streamer'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/streamer`
      }]
    }
  },
}

export const META_NEWS = {
  metaInfo() {
    return {
      title: this.$t('meta.title.news'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.news'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/news`
      }]
    }
  },
}

export const META_FAQ = {
  metaInfo() {
    return {
      title: this.$t('meta.title.faq'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.faq'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/faq`
      }]
    }
  },
}

export const META_CONTACT = {
  metaInfo() {
    return {
      title: this.$t('meta.title.contact'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.contact'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/contact`
      }]
    }
  },
}

export const META_TERMSSERVICE = {
  metaInfo() {
    return {
      title: this.$t('meta.title.termsService'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.termsService'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/terms`
      }]
    }
  },
}

export const META_PRIVACYPOLICY = {
  metaInfo() {
    return {
      title: this.$t('meta.title.privacyPolicy'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.privacyPolicy'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}/assets${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/policy`
      }]
    }
  },
}

export const META_TRADELAW = {
  metaInfo() {
    return {
      title: this.$t('meta.title.tradelaw'),

      meta: [{
        'property': 'og:title',
        'content': this.$t('meta.title.tradelaw'),
      }, {
        'property': 'og:description',
        'content': 'Description metadata',
      }, {
      //   'property': 'og:image',
      //   'content': `${window.origin}${image}`
      // }, {
        'property': 'og:url',
        'content': `${window.origin}/tradelaw`
      }]
    }
  },
}

export const META_APPLICATION = {}
